var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2145 12.6136V8.18182H6.3885C6.218 8.18182 6.05448 8.10998 5.93392 7.98212C5.81336 7.85425 5.74563 7.68083 5.74563 7.5C5.74563 7.31917 5.81336 7.14575 5.93392 7.01788C6.05448 6.89002 6.218 6.81818 6.3885 6.81818H12.2145V2.38636C12.2139 1.75367 11.9766 1.14708 11.5548 0.699697C11.1329 0.252314 10.561 0.000676801 9.96445 0H2.25004C1.65349 0.000676801 1.08155 0.252314 0.659726 0.699697C0.2379 1.14708 0.000638137 1.75367 0 2.38636V12.6136C0.000638137 13.2463 0.2379 13.8529 0.659726 14.3003C1.08155 14.7477 1.65349 14.9993 2.25004 15H9.96445C10.561 14.9993 11.1329 14.7477 11.5548 14.3003C11.9766 13.8529 12.2139 13.2463 12.2145 12.6136ZM15.8053 8.18182L13.6887 10.4271C13.5732 10.556 13.5098 10.7277 13.5119 10.9055C13.5141 11.0833 13.5816 11.2531 13.7002 11.3789C13.8187 11.5046 13.9789 11.5762 14.1465 11.5785C14.3141 11.5808 14.476 11.5135 14.5975 11.3911L17.8119 7.98196C17.9323 7.85411 18 7.68075 18 7.5C18 7.31925 17.9323 7.14589 17.8119 7.01804L14.5975 3.60895C14.476 3.48648 14.3141 3.41921 14.1465 3.42149C13.9789 3.42377 13.8187 3.49541 13.7002 3.62113C13.5816 3.74686 13.5141 3.91673 13.5119 4.09452C13.5098 4.27232 13.5732 4.44396 13.6887 4.57287L15.8053 6.81818H12.2145V8.18182H15.8053Z",
    fill: "#CB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.4be2606398010da4df32f5086f42f427.svg";
export { ForwardRef as ReactComponent };